























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeReferensi } from "@/store/modules/referensi";

interface AutocompleteOptions {
  outlined: true;
  label: "";
}

@Component({
  components: {},
})
export default class StatusAutoComplete extends Vue {
  @Prop() setStatus!: object;

  @Prop({
    default: () => {
      return {
        outlined: true,
        label: null,
      };
    },
  })
  opt: AutocompleteOptions;

  get listStatus() {
    return storeReferensi.status;
  }

  // bed = {};

  // list = [];

  searchStatus = null;

  loading = false;

  @Watch("setStatus")
  valStatus(val) {
    this.$emit("status", val);
  }
}
